const state = {
  media: '',
  isVideo: false,
  open: false,
}

const getters = {
  openMedia: state => state.open
}

const actions = {
  openMediaPopup: ({ commit }, { media, isVideo = false }) => {
    commit('openMediaPopup', {
      media, isVideo
    });
  },
  closeMediaPopup: ({ commit }) => {
    commit('closeMediaPopup');
  }
}

const mutations = {
  openMediaPopup: (state, { media, isVideo }) => {
    state.media = media;
    state.isVideo = isVideo;
    state.open = true;
  },
  closeMediaPopup: (state) => {
    state.open = false;
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
